import styled from 'styled-components';

export const IOS_STORE_URL = 'https://apps.apple.com/kr/app/id6743686410';
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.samlab.letmeupapp';

const AppleIcon = () => (
  <svg width="23" height="23" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.37 1.43c.04 1.06-.36 2.1-1.05 2.86-.72.79-1.9 1.4-3.04 1.31-.05-1.02.39-2.08 1.05-2.79.74-.8 1.99-1.39 3.04-1.38ZM20.5 17.2c-.55 1.27-.82 1.84-1.53 2.96-.99 1.56-2.39 3.5-4.12 3.51-1.54.02-1.93-.99-4.02-.98-2.09.01-2.52 1-4.06.97-1.73-.02-3.06-1.78-4.05-3.34-2.77-4.36-3.06-9.48-1.35-12.2 1.21-1.93 3.13-3.06 4.93-3.06 1.83 0 2.98 1 4.5 1 1.47 0 2.36-1 4.48-1 1.6 0 3.3.87 4.51 2.38-3.96 2.17-3.32 7.82.28 9.8Z" />
  </svg>
);

const GooglePlayIcon = () => (
  <svg width="21" height="23" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3.6 2.1c-.3.2-.5.6-.5 1.1v17.6c0 .5.2.9.5 1.1l9.3-9.9L3.6 2.1Z" fill="#00d7df" />
    <path d="m16.5 8.6-3.6-2.1L4.4 1.6c-.4-.2-.8-.2-1 .1l9.3 9.4 3.8-2.5Z" fill="#00e676" />
    <path d="m20.3 10.7-3-1.7-4 2.6 4 4 3-1.7c.9-.5.9-1.7 0-2.2v-1Z" fill="#ffc107" />
    <path d="m12.2 11.6-9.3 9.4c.3.3.7.3 1 .1l11.6-6.6-3.3-2.9Z" fill="#ff3d00" />
  </svg>
);

const AppStoreButtons = ({ className }: { className?: string }) => (
  <StoreRow className={className}>
    <StoreButton href={IOS_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="앱스토어에서 렛미업 받기">
      <AppleIcon />
      <StoreLabel><small>아이폰 · 아이패드</small><strong>앱스토어에서 받기</strong></StoreLabel>
    </StoreButton>
    <StoreButton href={ANDROID_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="구글 플레이에서 렛미업 받기">
      <GooglePlayIcon />
      <StoreLabel><small>안드로이드</small><strong>구글 플레이에서 받기</strong></StoreLabel>
    </StoreButton>
  </StoreRow>
);

export default AppStoreButtons;

const StoreRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
`;

const StoreButton = styled.a`
  min-width: 0;
  min-height: 3.25rem;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 0.65rem;
  padding: 0.55rem 0.65rem;
  background: #050505;
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  &:hover { color: #fff; border-color: #5ce2dc; text-decoration: none; filter: brightness(1.1); }
  svg { flex: 0 0 auto; }
`;

const StoreLabel = styled.span`
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  small { color: rgba(255, 255, 255, 0.72); font-size: 0.58rem; white-space: nowrap; }
  strong { margin-top: 0.15rem; font-size: 0.78rem; white-space: nowrap; }
`;
